import { z } from "zod";

/**
 * Class Template Schema - Template คลาสเรียน
 */
export const ClassTemplateSchema = z.object({
  id: z.string(),
  classTypeId: z.string(),
  classTypeName: z.string(),
  levelId: z.string(),
  levelName: z.string(),
  duration: z.number(),
  description: z.string().nullable(),
  status: z.enum(["active", "inactive"]),
  onlineRegistration: z.boolean(),
  createdBy: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  sessionsCount: z.number().optional(),
  allowedInstructorIds: z.array(z.string()).optional(),
});
export type ClassTemplateDTO = z.infer<typeof ClassTemplateSchema>;

/**
 * Create Class Template Schema
 */
export const CreateClassTemplateSchema = z.object({
  classTypeId: z.string().min(1, "ຕ້ອງເລືອກປະເພດຄລາດສ໌"),
  levelId: z.string().min(1, "ຕ້ອງເລືອກລະດັບ"),
  duration: z
    .number()
    .int("ລາຍການຕ້ອງເປັນຈຳນວນເຕັມ")
    .positive("ລາຍການຕ້ອງເປັນຈຳນວນບວກ"),
  description: z.string().nullable().optional(),
  status: z.enum(["active", "inactive"]).default("active"),
  onlineRegistration: z.boolean().default(false),
  allowedInstructorIds: z.array(z.string()).optional(),
});
export type CreateClassTemplateDTO = z.infer<
  typeof CreateClassTemplateSchema
>;

/**
 * Update Class Template Schema
 */
export const UpdateClassTemplateSchema = z.object({
  classTypeId: z.string().min(1, "ຕ້ອງເລືອກປະເພດຄລາດສ໌").optional(),
  levelId: z.string().min(1, "ຕ້ອງເລືອກລະດັບ").optional(),
  duration: z
    .number()
    .int("ລາຍການຕ້ອງເປັນຈຳນວນເຕັມ")
    .positive("ລາຍການຕ້ອງເປັນຈຳນວນບວກ")
    .optional(),
  description: z.string().nullable().optional(),
  status: z.enum(["active", "inactive"]).optional(),
  onlineRegistration: z.boolean().optional(),
  allowedInstructorIds: z.array(z.string()).optional(),
});
export type UpdateClassTemplateDTO = z.infer<
  typeof UpdateClassTemplateSchema
>;
